/** SMART FORMAT TOOL — single-text Smart Format (brand emphasis profile) + bulk wizard launcher. */
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Sparkles, Copy } from "lucide-react";
import SmartFormatBulk from "@/components/technology/SmartFormatBulk";

export default function SmartFormatTool() {
  const [brand, setBrand] = useState("");
  const [text, setText] = useState("");
  const [out, setOut] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/descriptions/smart-format", { text, brand: brand || null, context: { ref: "product-format-centre" } }); setOut(data); }
    catch (e) { toast.error(e.response?.data?.detail || "Smart Format failed"); }
    setBusy(false);
  };
  const copy = () => navigator.clipboard?.writeText(out?.formatted || "").then(() => toast.success("Copied")).catch(() => toast.error("Copy failed"));
  return (
    <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_300px]" data-testid="sft-root">
      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <div className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">Smart Format a specification</div>
        <div className="mt-2 flex gap-2"><Input value={brand} onChange={(e) => setBrand(e.target.value)} placeholder="Brand (uses its emphasis profile)" className="max-w-xs" data-testid="sft-brand" /></div>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="Paste the raw specification — key facts get **bold** emphasis, text is never changed" className="mt-2 min-h-[120px]" data-testid="sft-text" />
        <div className="mt-2 flex gap-2">
          <Button disabled={busy || !text.trim()} onClick={run} className="bg-slate-900 hover:bg-slate-800" data-testid="sft-run"><Sparkles className="mr-1.5 h-4 w-4" />Smart Format</Button>
          {out && <Button variant="outline" onClick={copy} data-testid="sft-copy"><Copy className="mr-1.5 h-4 w-4" />Copy</Button>}
        </div>
        {out && <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-3 text-[13px] leading-relaxed" data-testid="sft-output">
          <div className="text-[10px] uppercase tracking-widest text-slate-500">Result · bold ratio {Math.round((out.bold_ratio || 0) * 100)}%{out.changed ? "" : " · nothing to emphasise"}</div>
          <div className="mt-1 whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: (out.formatted || "").replace(/\*\*(.+?)\*\*/g, "<b>$1</b>") }} />
        </div>}
      </div>
      <div className="space-y-2">
        <div className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">Bulk — Product Master</div>
        <SmartFormatBulk />
      </div>
    </div>
  );
}
